/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */

// The following polyfills are needed for IE11
import 'core-js/fn/object/assign';
import 'core-js/fn/number/is-integer';

export * from './contract/Enums';
export * from './interface/InternalApiDispatcher';
export * from './contract/Models';
export * from './contract/Notifications';
export * from './contract/Parameters';
export * from './contract/Verbs';
export * from './interface/VersionNumber';
export * from './versioning/VersionConverterFactory';
export * from './versioning/InternalContractVersionConverter';

// These are the exports from the messaging stuff

export * from './messaging/CrossFrameMessenger';
export * from './messaging/interface/MessageDispatcher';
export * from './messaging/interface/MessageListener';
export * from './messaging/interface/MessageTypes';
export * from './messaging/interface/Messenger';
export * from './messaging/interface/PreparedMessage';

// Export a hardcoded version of the internal contract. This should match what's in package.json.
// Normally, we'd use some sort of webpack replacement to inject this into code, but that doesn't
// work with the module-dev-scripts and this isn't too much work.
// If you forget to keep this in sync with package.json, a test will fail so we should be ok.
export const INTERNAL_CONTRACT_VERSION = {
  major: 1,
  minor: 4,
  fix: 2
};

// Export the version number of messaging for consumers to use.
// Be very careful making any updates to this contract which break version compatibility.
export const MESSAGING_VERSION = {
  major: 1,
  minor: 0,
  fix: 0
};



// WEBPACK FOOTER //
// ../../src/JsApiInternalContract.ts


// WEBPACK FOOTER //
// webpack:///src/JsApiInternalContract.ts